<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div @click="copyText()" class="text-truncate text-to-copy" style="width: 100px">
        <span v-bind="attrs" v-on="on"> {{ text }}</span>
      </div>
    </template>
    <div class="d-flex flex-column align-center">
      <span class="text-justify" style="max-width: 400px">
        {{ text }}
      </span>
      <div v-if="shouldCopy">
        <span v-if="copied" style="font-size: 0.75rem">Copiado!</span>
        <span v-else style="font-size: 0.75rem">Clique para copiar</span>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
import copyToClipboard from '@/utils/copyToClipboard';
export default {
  props: {
    text: {
      default: null,
      type: [String, Number]
    },
    shouldCopy: {
      default: false,
      type: Boolean
    }
  },

  data: () => ({
    copied: false
  }),

  methods: {
    copyText() {
      if (!this.shouldCopy) return;
      this.copied = true;
      copyToClipboard(this.text);
      setTimeout(() => {
        this.copied = false;
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-to-copy {
  width: 100px;
}
</style>
